import React from 'react';
import fallbackAvatar from '../assets/images/fallback-account-avatar.svg';

// Base64 Encode of 1x1px Transparent GIF
const transparentGIF = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';

interface AccountAvatarProps {
  backgroundImageURL: string;
  minWidth: string | number;
  maxHeight: string | number;
}

const AccountAvatar: React.FC<AccountAvatarProps> = (props: AccountAvatarProps) => {
  const { backgroundImageURL, minWidth, maxHeight } = props;
  return (
    <div
      style={{
        backgroundImage: `url(${fallbackAvatar})`,
        borderRadius: '50%',
        marginLeft: 4,
        minWidth,
        maxHeight,
        backgroundPosition: 'center',
        backgroundSize: 'cover',
      }}
    >
      <img
        style={{
          backgroundImage: `url(${backgroundImageURL})`,
          borderRadius: '50%',
          marginLeft: 4,
          minWidth,
          maxHeight,
          backgroundPosition: 'center',
          backgroundSize: 'cover',
        }}
        src={transparentGIF}
        alt=""
      />
    </div>
  );
};

export default AccountAvatar;
